/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 25 2024
 **/

import styled from "@emotion/styled";

import { TabContent, Row } from "@/frameworks/designStuff/components";

export const FullSizeSpaceNavWrap = styled.div`
	width: 100%;
	display: flex;
	padding-left: 16px;
	padding-right: 16px;
	border-bottom: 1px solid #878b9333;
`;

export const StyledTabContent = styled(TabContent)`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const SearchedResultWrapper = styled(Row)`
	height: inherit;
	width: inherit;
	#total-count {
		padding: 4px 60px;
	}
	#content-wrapper {
		padding: 30px 60px;
	}
`;
